import React from 'react'
export const utilityKeysIds = ['left', 'right', 'arrowup', 'arrowdown', 'del']
export const utilityKeysProps = [
  {
    id: '{arrowright}',
    label: 'right',
    labelType: 'raw',
    mathfieldInstructions: {
      content: 'Right',
      method: 'keystroke',
    },
    isUtilityKey: true,
    group: 'utility',
  },
  // {
  //   id: 'right',
  //   label: 'right',
  //   labelType: 'raw',
  //   mathfieldInstructions: {
  //     content: 'Right',
  //     method: 'keystroke',
  //   },
  //   isUtilityKey: true,
  //   group: 'utility',
  // },
  // {
  //   id: 'arrowup',
  //   label: 'arrowup',
  //   labelType: 'raw',
  //   mathfieldInstructions: {
  //     content: 'Up',
  //     method: 'keystroke',
  //   },
  //   isUtilityKey: true,
  //   group: 'utility',
  // },
  // {
  //   id: 'arrowdown',
  //   label: 'arrowdown',
  //   labelType: 'raw',
  //   mathfieldInstructions: {
  //     content: 'Down',
  //     method: 'keystroke',
  //   },
  //   isUtilityKey: true,
  //   group: 'utility',
  // },
  // {
  //   id: 'del',
  //   label: 'del',
  //   labelType: 'raw',
  //   mathfieldInstructions: {
  //     content: 'Backspace',
  //     method: 'keystroke',
  //   },
  //   isUtilityKey: true,
  //   group: 'utility',
  // },
  {
    // new addtion start here
    id: '{arrowleft}',
    label: 'left',
    labelType: 'raw',
    mathfieldInstructions: {
      content: 'Left',
      method: 'keystroke',
    },
    isUtilityKey: true,
    group: 'utility',
  },
  {
    // new addtion start here
    id: '{arrowdown}',
    label: 'down',
    labelType: 'raw',
    mathfieldInstructions: {
      content: 'Down',
      method: 'keystroke',
    },
    isUtilityKey: true,
    group: 'utility',
  },
  {
    // new addtion start here
    id: '{arrowup}',
    label: 'Up',
    labelType: 'raw',
    mathfieldInstructions: {
      content: 'Up',
      method: 'keystroke',
    },
    isUtilityKey: true,
    group: 'utility',
  },
]
